export { default } from "./FailedToLoadData";



// WEBPACK FOOTER //
// ./src/components/common/errorBoundary/failedToLoadData/index.js